import { __ } from '@wordpress/i18n';

document.addEventListener("DOMContentLoaded", function() {
    const container = document.getElementById('mapa-territorios');
    if (!container) return;

    const isSingle = container.hasAttribute('data-post-id');
    const singlePostId = isSingle ? parseInt(container.getAttribute('data-post-id')) : null;

    const featuresList = {};

    let center = [-51.602449, -18.44969];
    let zoom = 3.54;

    if (typeof hl_mapa_territorios_data !== 'undefined' && isSingle && singlePostId) {
        const territorio = hl_mapa_territorios_data.pontos.find(function(t) {
            return t.id === singlePostId;
        });
        if (territorio) {
            center = [territorio.lng, territorio.lat];
            zoom = 8;
        }
    }

    const map = new maplibregl.Map({
        container: 'mapa-territorios',
        style: 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json',
        center: center,
        zoom: zoom,
        scrollZoom: false
    });

    function fitBounds (features) {
        if (!features?.features) {
            return;
        }

        const bounds = new maplibregl.LngLatBounds();

        for (const feature of features.features) {
            const geometry = feature.geometry;
            if (!geometry) continue;

            if (geometry.type === 'Polygon') {
                for (const ring of geometry.coordinates) {
                    for (const coord of ring) {
                        bounds.extend(coord);
                    }
                }
            } else if (geometry.type === 'MultiPolygon') {
                for (const polygon of geometry.coordinates) {
                    for (const ring of polygon) {
                        for (const coord of ring) {
                            bounds.extend(coord);
                        }
                    }
                }
            }
        }

        map.fitBounds(bounds, { padding: 25 });
    }

    async function fetchFeatures (territory, jsonUrl) {
        if (!featuresList[territory]) {
            const res = await fetch(jsonUrl);
            if (res.ok) {
                const jsonData = await res.json();
                featuresList[territory] = jsonData;
            }
        }

        return featuresList[territory];
    }

    async function setFeatures (territory) {
        const features = await fetchFeatures(territory, `${hl_mapa_territorios_data.assetsUrl}/geojson/territory/${territory}.json`);

        if (features) {
            map.getSource('mjc').setData(features);
            fitBounds(features);
        }
    }

    map.addControl(new maplibregl.NavigationControl());

    map.on('style.load', async function() {
        // Localized basemap labels: the CARTO vector tiles carry localized
        // name properties (name:pt / name:en / name:es — verified on the
        // tile payloads). Re-target every symbol layer's text-field to the
        // active WPML language, falling back to Portuguese (site doctrine)
        // and then to the local name.
        const mapLang = (typeof hl_mapa_territorios_data !== 'undefined' && hl_mapa_territorios_data.lang)
            ? hl_mapa_territorios_data.lang
            : 'pt';

        const layers = map.getStyle().layers;
        layers.forEach(function(layer) {
            if (layer.type === 'symbol' && layer.layout && layer.layout['text-field']) {
                map.setLayoutProperty(layer.id, 'text-field', [
                    'coalesce',
                    ['get', 'name:' + mapLang],
                    ['get', 'name:pt'],
                    ['get', 'name']
                ]);
            }
        });

        if (typeof hl_mapa_territorios_data !== 'undefined') {
            const features = await fetchFeatures(hl_mapa_territorios_data.territorio, hl_mapa_territorios_data.featuresUrl);
            if (!features) {
                return;
            }

            map.addSource('mjc', {
                type: 'geojson',
                data: features,
            });

            fitBounds(features);

            map.addLayer({
                id: 'mjc-fill',
                type: 'fill',
                source: 'mjc',
                layout: {},
                paint: {
                    'fill-color': '#FFA902',
                    'fill-opacity': 0.5,
                },
            });

            map.addLayer({
                id: 'mjc-line',
                type: 'line',
                source: 'mjc',
                layout: {},
                paint: {
                    'line-color': '#E26B00',
                    'line-opacity': 0.5,
                    'line-width': 2,
                },
            });

            map.addLayer({
                id: 'mjc-text',
                type: 'symbol',
                source: 'mjc',
                layout: {
                    'text-anchor': 'center',
                    'text-field': '{name}',
                    'text-font': ['Cabin Bold', 'Open Sans Bold'],
                    'text-size': 12,
                },
                paint: {
                    'text-color': '#540000',
                },
            });
        }
    });

    if (typeof hl_mapa_territorios_data !== 'undefined') {
        const caminhoAssets = hl_mapa_territorios_data.assetsUrl;
        const listaTerritorios = hl_mapa_territorios_data.pontos;

        listaTerritorios.forEach(function(territorio) {
            if (isSingle && territorio.id !== singlePostId) return;

            const urlTerritorio = territorio.url ? territorio.url : '#';

            const popupHTML = `
                <div class="territorio-popup -links-disabled" data-territorio="${territorio.territorio}">
                    <h3>${territorio.nome}</h3>

                    <div class="territorio-popup__body">
                        <div class="territorio-popup__info-col">
                            <p class="territorio-popup__descricao">${territorio.descricao}</p>
                            <p><strong>${__( 'Population:', 'hacklabr' )}</strong> ${territorio.populacao} ${__( 'inhabitants', 'hacklabr' )}</p>
                        </div>
                        <div class="territorio-popup__content-wrapper">
                            <div class="territorio-popup__orgs">
                                <strong>${__( 'Municipalities of the Territory:', 'hacklabr' )}</strong>
                                ${territorio.municipios}
                            </div>
                        </div>
                    </div>

                    <a href="${urlTerritorio}" class="territorio-popup__link">
                        ${__( 'Full profile', 'hacklabr' )}
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </a>
                </div>
            `;

            const isMobile = window.innerWidth < 768;

            const popup = new maplibregl.Popup({
                offset: 25,
                closeButton: true,
                maxWidth: isMobile ? '300px' : '560px'
            })
            .setHTML(popupHTML);

            const clampPopup = function() {
                if (!popup.isOpen()) return;

                const popupEl = popup.getElement();
                if (!popupEl) return;

                const popupCard = popupEl.querySelector('.territorio-popup');

                // Reset
                popupEl.style.marginLeft = '0px';
                popupEl.style.marginTop = '0px';
                if (popupCard) {
                    popupCard.style.maxHeight = '';
                    popupCard.style.overflowY = '';
                }

                const mapRect = map.getContainer().getBoundingClientRect();
                const pad = 8;
                const maxCardWidth = isMobile ? 300 : 560;

                popup.setMaxWidth(Math.max(0, Math.min(maxCardWidth, mapRect.width - pad * 2)) + 'px');

                if (popupCard) {
                    const maxCardHeight = mapRect.height - pad * 2;
                    if (popupCard.scrollHeight > maxCardHeight) {
                        popupCard.style.maxHeight = maxCardHeight + 'px';
                        popupCard.style.overflowY = 'auto';
                    }
                }

                const popupRect = popupEl.getBoundingClientRect();

                let dx = 0;
                let dy = 0;

                if (popupRect.left < mapRect.left + pad) {
                    dx = mapRect.left + pad - popupRect.left;
                } else if (popupRect.right > mapRect.right - pad) {
                    dx = mapRect.right - pad - popupRect.right;
                }

                if (popupRect.top < mapRect.top + pad) {
                    dy = mapRect.top + pad - popupRect.top;
                } else if (popupRect.bottom > mapRect.bottom - pad) {
                    dy = mapRect.bottom - pad - popupRect.bottom;
                }

                popupEl.style.marginLeft = dx + 'px';
                popupEl.style.marginTop = dy + 'px';
            };

            const onMapMove = function() {
                clampPopup();
            };

            popup.on('open', function() {
                const popupEl = popup.getElement();

                if (!isSingle && popupEl) {
                    const territoryId = popupEl.querySelector('[data-territorio]')?.dataset.territorio;
                    if (territoryId) {
                        setFeatures(territoryId);
                    }
                }

                clampPopup();
                map.on('move', onMapMove);
                map.on('resize', onMapMove);

                imgIcone.src = `${caminhoAssets}/images/map-pin-verde.svg`;
                elIcone.style.zIndex = 1;
            });

            const elIcone = document.createElement('div');
            elIcone.className = 'marcador-feijao';

            const imgIcone = document.createElement('img');
            imgIcone.src = `${caminhoAssets}/images/map-pin.svg`;
            imgIcone.style.width = '48px';
            imgIcone.style.height = 'auto';
            imgIcone.style.cursor = 'pointer';

            elIcone.appendChild(imgIcone);

            new maplibregl.Marker({
                element: elIcone,
                anchor: 'bottom'
            })
            .setLngLat([territorio.lng, territorio.lat])
            .setPopup(popup)
            .addTo(map);

            popup.on('close', () => {
                map.off('move', onMapMove);
                map.off('resize', onMapMove);

                imgIcone.src = `${caminhoAssets}/images/map-pin.svg`;
                elIcone.style.zIndex = '';

                if (!isSingle) {
                    setFeatures('@all');
                }
            });
        });
    }
});
